var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/my"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5 12.3C5 9.56977 5 8.20464 5.53134 7.16183C5.99873 6.24454 6.74451 5.49875 7.6618 5.03137C8.70462 4.50003 10.0697 4.50003 12.8 4.50003H23.2C25.9303 4.50003 27.2954 4.50003 28.3382 5.03137C29.2555 5.49875 30.0013 6.24454 30.4687 7.16183C31 8.20464 31 9.56977 31 12.3V31.498L26.5312 28.6L22.4688 31.498L18 28.6L13.5312 31.498L9.46875 28.6L5 31.498V12.3Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M5 12.3C5 9.56977 5 8.20464 5.53134 7.16183C5.99873 6.24454 6.74451 5.49875 7.6618 5.03137C8.70462 4.50003 10.0697 4.50003 12.8 4.50003H23.2C25.9303 4.50003 27.2954 4.50003 28.3382 5.03137C29.2555 5.49875 30.0013 6.24454 30.4687 7.16183C31 8.20464 31 9.56977 31 12.3V31.498L26.5312 28.6L22.4688 31.498L18 28.6L13.5312 31.498L9.46875 28.6L5 31.498V12.3Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 3004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-25-path",
    d: "M11 12H25",
    stroke: "white",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-25-path_2",
    d: "M11 17H25",
    stroke: "white",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-25-path_3",
    d: "M11 22H18",
    stroke: "white",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconOrder);
export default __webpack_public_path__ + "static/media/nav_icon_order.daafc64864a76bf5af8a58632f2265cd.svg";
export { ForwardRef as ReactComponent };